export const PASSWORD_CRITERIA_LEFT = [
  { id: "minLength", label: "At least 8 characters", test: (password) => password.length >= 8 },
  { id: "uppercase", label: "One uppercase letter", test: (password) => /[A-Z]/.test(password) },
  { id: "special", label: "One special character", test: (password) => /[^A-Za-z0-9]/.test(password) },
];

export const PASSWORD_CRITERIA_RIGHT = [
  { id: "lowercase", label: "One lowercase letter", test: (password) => /[a-z]/.test(password) },
  { id: "number", label: "One number", test: (password) => /\d/.test(password) },
];

export const PASSWORD_CRITERIA = [...PASSWORD_CRITERIA_LEFT, ...PASSWORD_CRITERIA_RIGHT];

/** Row-major order for two criteria per row in the UI. */
export const PASSWORD_CRITERIA_ROWS = [
  PASSWORD_CRITERIA_LEFT[0],
  PASSWORD_CRITERIA_RIGHT[0],
  PASSWORD_CRITERIA_LEFT[1],
  PASSWORD_CRITERIA_RIGHT[1],
  PASSWORD_CRITERIA_LEFT[2],
];

export const getPasswordCriteriaState = (password) =>
  PASSWORD_CRITERIA.map((criterion) => ({
    ...criterion,
    met: criterion.test(password),
  }));

export const isPasswordValid = (password) => PASSWORD_CRITERIA.every((criterion) => criterion.test(password));

export const PASSWORD_CRITERIA_INVALID_MESSAGE =
  "Password must meet all requirements: 8+ characters, uppercase, lowercase, number, and special character.";
